// src/routes/publicRoutes.tsx

import {
  Link,
  NavLink,
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import InicioController from "../resource/public/controllers/InicioController";
import EntradasController from "../resource/public/controllers/EntradasController";
import EntradaController from "../resource/public/controllers/EntradaController";
import VideosController from "../resource/public/controllers/VideosController";
import PagoController from "../resource/public/controllers/PagoController";
import SalasController from "../resource/public/controllers/SalasController";
import SalaController from "../resource/public/controllers/SalaController";
import FestivalesController from "../resource/public/controllers/FestivalesController";
import TerminosYCondiciones from "../resource/public/page/TerminosYCondiciones";
import LoginController from "../resource/web/controllers/auth/LoginController";
import RegisterController from "../resource/web/controllers/auth/RegisterController";
import RestaurarController from "../resource/web/controllers/auth/RestaurarController";
import ContraseñaController from "../resource/web/controllers/auth/ContraseñaController";
import UsuarioController from "../resource/web/controllers/usuarios/UsuarioController";
import { NotasController } from "../resource/public/controllers/NotasController";
import { NotaController } from "../resource/public/controllers/NotaController";
import Completado from "../resource/public/page/Completado";

const PublicRoutes = [
  <Route path="/" element={<InicioController />} />,
  <Route path="/inicio" element={<InicioController />} />,
  <Route path="/entradas" element={<EntradasController />} />,
  <Route path="/entradas/:search" element={<EntradasController />} />,
  <Route path="/entrada/:slug" element={<EntradaController />} />,
  <Route path="/evento/:slug" element={<EntradaController />} />,
  <Route path="/nevadas13" element={<FestivalesController />} />,
  <Route path="/festivales" element={<FestivalesController />} />,
  <Route path="/contenidos/videos" element={<VideosController />} />,
  <Route path="/contenidos/notas" element={<NotasController />} />,
  <Route path="/contenidos/notas/:slug" element={<NotaController />} />,
  //<Route path="/checkout" element={<PagoController />} />,
  <Route path="/checkout/:evento_id" element={<PagoController />} />,
  <Route path="/checkout/:evento_id/:metodo_pago" element={<PagoController />} />,
  <Route path="/completado/:evento_id" element={<Completado />} />,
  <Route path="/salas" element={<SalasController />} />,
  <Route path="/sala/:slug" element={<SalaController />} />,
  <Route path="/terminos-y-condiciones" element={<TerminosYCondiciones />} />,
  <Route path="/login" element={<LoginController />} />,
  <Route path="/registro/:tipo" element={<RegisterController />} />,
  <Route path="/restaurar" element={<RestaurarController />} />,
  <Route path="/cambio-contraseña/:token" element={<ContraseñaController />} />,
  <Route path="/perfil" element={<UsuarioController />} />,
  <Route path="/v/configuracion" element={<></>} />,
  <Route path="/v/usuarios/:tipo" element={<></>} />,
];

export default PublicRoutes;
